import { useEffect, useState } from 'react';
import { LivestreamSession } from 'cb-model';
import { fetchApi, useCacheRecord } from 'gossamer-front-end';

interface LivestreamRecordingStatus {
  file: boolean;
  playlist: boolean;
  loaded: boolean;
  hasVideoRecording: boolean;
}

export const useLivestreamStatus = (livestreamSessionId: string) => {
  const [recordingStatus, setRecordingStatus] = useState<LivestreamRecordingStatus>({
    file: false,
    playlist: false,
    loaded: false,
    hasVideoRecording: false,
  });
  const livestreamSessionRecord = useCacheRecord(LivestreamSession, livestreamSessionId, !livestreamSessionId);

  useEffect(() => {
    if (livestreamSessionRecord.data?.status === 'COMPLETED') {
      fetchApi('GET', `/main/livestream/recordings/${livestreamSessionId}/status`, {
        method: 'GET',
        credentials: 'include',
      })
        .then((response) => {
          setRecordingStatus({ ...response, loaded: true, hasVideoRecording: response.file && response.playlist });
        })
        .catch((error) => {
          console.error('Error fetching recording status:', error);
        });
    }
  }, [livestreamSessionRecord.data?.status, livestreamSessionId]);

  return recordingStatus;
};
